import { render, staticRenderFns } from "./AscDeletePowerBiReportDialog.vue?vue&type=template&id=487ffdba&"
import script from "./AscDeletePowerBiReportDialog.vue?vue&type=script&lang=js&"
export * from "./AscDeletePowerBiReportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports